<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';
    import AlternativesViewDependenciesList from "@Alternatives/AlternativesViews/Components/AlternativesViewDependenciesList.vue";
    import { AlternativesViewDeleterDialogViewModel } from "@Alternatives/AlternativesViews/Components/AlternativesViewDeleterDialog";

    @Component({
        components: { AlternativesViewDependenciesList },
        props: {
            viewModel: {
                type: Object,
                required: true
            }
        }
    })
    export default class AlternativesViewDeleterDialog extends Vue
    {
        get vm(): AlternativesViewDeleterDialogViewModel { return this.$props.viewModel as AlternativesViewDeleterDialogViewModel; }
        get opened(): boolean { return this.vm?.opened ?? false; }

        get initialized(): boolean { return this.vm?.initialized ?? false; }
        get canDelete(): boolean { return this.vm?.hasDependants === false; }
        get name(): string { return this.vm.name; }
        get dependenciesCount(): number | null { return this.vm.dependenciesCount }

        get reports() { return this.vm.reports; }
        get lists() { return this.vm.lists; }
        get estimationsSurveys() { return this.vm.estimationsSurveys; }

        deleteList()
        {
            this.$emit('delete-list', this.vm.id);
        }

        close()
        {
            this.vm.close();
        }
    }

</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-lg modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header" :class="{'bg-danger': canDelete}">
                        <h5 class="modal-title">Delete attribute</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>
                    <div class="modal-body">
                        <h4 v-if="!initialized">
                            <i class="fa fa-spinner fa-spin"></i> Checking dependencies...
                        </h4>
                        <div v-if="canDelete">
                            <h4>Are you sure you want to delete this list?</h4>
                            <p>You are about to delete '<strong>{{name}}</strong>'. This can't be undone.</p>
                        </div>
                        <div v-if="!canDelete">
                            <div class="alert alert-danger text-dark" role="alert">
                                <h5 class="alert-heading">Cannot delete this list</h5>
                                <p>
                                    The list '<strong>{{name}}</strong>' is used in <strong>{{dependenciesCount}}</strong> places.
                                    To delete this list, first remove it from where it is used.
                                </p>
                            </div>
                            <AlternativesViewDependenciesList :initialized="initialized"
                                                              :reports="reports"
                                                              :lists="lists"
                                                              :estimationsSurveys="estimationsSurveys" />
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button v-if="canDelete" type="button" class="btn btn-danger" @click="deleteList">Delete</button>
                        <button type="button" class="btn btn-outline-secondary" @click="close">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .modal-header.bg-danger .modal-title,
    .modal-header.bg-danger .close {
        color: white;
    }

</style>